import React from 'react';
import { BaseLayoutFactory } from '../global/base-layout-factory';
import { AuditsProvider } from './context/audits-context';
import { AuditsComponent } from './audits-component';

export function AuditsFactory() {
  return (
    <BaseLayoutFactory>
      <AuditsProvider>
        <AuditsComponent />
      </AuditsProvider>
    </BaseLayoutFactory>
  );
}
